/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/js/aa/plugins/jquery/aaCarousel.js
*    TO   --> ./webapps/shared-web/src/main/assets/js/plugins/jquery.aaCarousel.js
**/

/*------------------------------------*\
	aaCarousel
\*------------------------------------*/

(function($) {

    $.fn.aaCarousel = function (options) {
    	var self = {},
    		_prevText = AAcom.prototype.getProperty('slider.previousText'),
    		_nextText = AAcom.prototype.getProperty('slider.nextText');

    	self.source = this;
    	self.flexObject = self.source.find('.flexslider');
    	self.slidesObject = self.flexObject.find('.slides');
    	if(self.slidesObject.children().length <= 0){
    		self.slidesObject.hide();
    		return false;
    	}

        options.directionNav = (options.directionNav !== undefined) ? options.directionNav : true;

        if(options.directionNav) {
    	   self.source.prepend('<div class="flex-direction-nav"><button type="button" class="flex-prev"><span class="hidden-accessible">'+_prevText+'</span></button></div>');
    	   self.source.append('<div class="flex-direction-nav"><button type="button" class="flex-next"><span class="hidden-accessible">'+_nextText+'</span></button></div>');
        }

        self.initCarousel = function() {

        	self.defaults = $.extend({
        		animation: 'slide',
                slideshow: false,
                animationLoop: false,
                animationSpeed: 300,
                controlNav: false,
                itemWidth: 138,
                itemMargin: 0,
                minItems: 5,
                maxItems: 5,
                move: 1,
                prevText: '',
                nextText: '',
                keyboard: false,
                useCSS: false,
                startAt: 0,
                customDirectionNav: self.source.find('.flex-direction-nav button'),
                selectedItem: 0,
                selectedItemText: '',
                selectedItemJSClass: '',
                type: 'default',
                trigger: 'click',
                selectedSlideClass: 'flex-selected-slide',
                disabledSlideClass: 'flex-disabled-slide',
                onStart: function() {},
                onBefore: function() {},
                onAfter: function() {},
                onEnd: function() {},
                onSelect: function() {}
        	}, options || {});

        	self.settings = $.extend(self.defaults, {
            	start: function(slider){
                	if(slider.vars !== undefined){
                		var $selectedItem = slider.container.find(slider.slides[slider.vars.selectedItem]);
                		$selectedItem.addClass(self.settings.selectedSlideClass);
                        if(slider.vars.selectedItemJSClass.length > 0) {
                		  $selectedItem.find('.'+slider.vars.selectedItemJSClass).html(slider.vars.selectedItemText);
                        }
                	}
                    if(slider.directionNav) {
                	    slider.directionNav.unbind('keyup');
                        if(slider.count <= slider.visible){
                            slider.directionNav.hide();
                        }
                    }
                	_setupTabIndex(slider);
                	_bindSelectEvent(slider);

                	self.settings.onStart(slider);
                	slider.resize();
                },
                before: function(slider) {
                    self.settings.onBefore(slider);
                },
                after: function(slider){
                	_setupTabIndex(slider);

                	self.settings.onAfter(slider);
                },
                end: function(slider){
                	self.settings.onEnd(slider);
                }
            });

            $.getScript('/assets/js/vendor/plugins/jquery.flexslider.min.js')
            .done(function( script, textStatus ) {
        			if(self.settings.type === "tabs"){
                		self.source.addClass("tab-carousel");
                	}
        			self.flexObject.show();
        			self.flexObject.flexslider(self.settings);
        		})
        		.fail(function( jqxhr, settings, exception ) {
        			console.log( "Couldn't load Flexslider." );
        	});
        };

        var _setupTabIndex = function(slider) {
        	var _currentSlide = slider.currentSlide,
        		_numberItemsVisible = slider.visible,
        		_maxItemVisible = _currentSlide + _numberItemsVisible,
                _disabledClass = slider.vars.namespace + 'disabled';

        	slider.slides.each(function(index, value){
        		var $self = $(this);
        		if( ((index >= _currentSlide) && (index < _maxItemVisible)) && (!$(this).hasClass(self.settings.disabledSlideClass))){
        			$self.find('button').attr({
                      'tabindex': '0',
                      'aria-hidden': 'false'
                    });
        		}
        		else{
        			$self.find('button').attr({
                      'tabindex': '-1',
                      'aria-hidden': 'true'
                    });
        		}
        	});
        };

        var _bindSelectEvent = function(slider) {
			var triggerEvent = self.settings.trigger;
			slider.container.on(triggerEvent, "li button", function(e) {
				e.preventDefault();
				var $self = $( this );

                if (!$self.parent('li').hasClass(self.settings.selectedSlideClass)) {
                    slider.slides.removeClass(self.settings.selectedSlideClass);
                    $self.parent('li').addClass(self.settings.selectedSlideClass);

                    if (slider.vars.selectedItemJSClass.length > 0) {
                        slider.slides.find('.'+slider.vars.selectedItemJSClass).empty();
                        $self.find('.'+slider.vars.selectedItemJSClass).html(slider.vars.selectedItemText);
                    }
                    self.settings.onSelect(this, slider);
                }
			});
		};
        self.moveSliderRight = function() {
            $('.flex-next').trigger('click');
        };
        return self;
    };
})(jQuery);
